import moment from 'moment'

function formatDate(date) {
  return new Date(new Date(date).toUTCString().substr(0, 25))
}

/**
 * Converts date string from short format to long text format including day and month names
 *
 * e.g., getDateFull("2024-02-14") returns "Wednesday, February 14" if current year is 2024
 * or "Wednesday, February 14, 2024" if current year is not 2024. Include true for keepSameYear
 * to always include year in the return value
 * @param {string} date - date string in "YYYY-MM-DD" or "MM/DD/YYYY" format
 * @param {boolean} keepSameYear - set true to include year in return string
 * @returns {string}
 */
export function getDateFull(date, keepSameYear = false) {
  const formattedDate = formatDate(date)
  const isSameYear = formattedDate.getFullYear() === new Date().getFullYear()
  const dateString = formattedDate.toLocaleString('en-us', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
  if (keepSameYear) return dateString
  return isSameYear ? dateString.slice(0, -6) : dateString
}

export function getDateCalendarFormat(date) {
  const newDate = new Date(date)
  return newDate ? `${newDate.getUTCMonth() + 1}/${newDate.getUTCDate()}/${newDate.getUTCFullYear()}` : date
}

export function createDateWithTimeZone(timeZone, year, month, day, hour, minute, second) {
  const date = new Date(Date.UTC(year, month, day, hour, minute, second))

  const utcDate = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }))
  const tzDate = new Date(date.toLocaleString('en-US', { timeZone }))
  const offset = utcDate.getTime() - tzDate.getTime()

  date.setTime(date.getTime() + offset)

  return date
}

export function getShortDateTime(date) {
  return formatDate(date).toLocaleDateString('en-us', { day: 'numeric', year: 'numeric', month: 'short' })
}

/**
 * Converts an input date string from YYYY-MM-DD format to MM/DD/YYYY format
 * @param {string} ymdDate
 * @returns {string}
 */
export function convertYMDtoMDY(ymdDate) {
  if (!ymdDate) return ''
  const [year, month, day] = ymdDate.split('-')
  return year && month && day ? `${month}/${day}/${year}` : ''
}

export function formatAvailableInDate(_date) {
  const date = moment(_date)
  if (!date.isValid()) return ''

  return date.format('dddd, MMMM Do')
}
